<template>
  <div class="choose-tags--page">
    <van-nav-bar
      title="选择标签"
      left-text="返回"
      right-text="保存"
      left-arrow
      @click-left="handleBack"
      @click-right="submit"
    />
    <div class="add-box row-flex">
      <div class="border-input">
        <input type="text" v-model="insetTagVal" maxlength="8" placeholder="请输入自定义标签" class="input row-flex-eq">
        <span class="plus" @click="plusBtn">
          <van-icon name="plus" />
        </span>
      </div>
    </div>    
    <van-checkbox-group v-model="result" :max="maxCount">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in tagList"
          clickable
          :key="item.Id"
          :title="item.Name"
          @click="toggle(index)"
        >
          <div class="flex-rev">
            <van-checkbox :name="item" ref="checkboxes" />
          </div>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </div>
</template>

<script>
import CommonMix from '@/mixins/commonMix.js'
import {Cms} from '@/api'
import publishTagServices from '@/services/publishTagServices'
export default {
  name: 'choose-tags',
  mixins: [CommonMix],
  data() {
    return {
      tagList: [],
      result: [],
      defaultResult: [],
      insetTagVal: '',
      maxCount: 5,
      UserId: this.$mdUtils.getUserInfo('Id')
    }
  },
  created() {
    this.getOwnTags()
  },
  methods: {
    getOwnTags() {
      this.$api(Cms.QueryTag,{UserId: this.UserId})
        .then((res) => {
          this.tagList = res.List
          this.setCurr()
        })
    },
    setCurr() {
      let ids = this.$route.query.ids
      if (ids && ids.length) {
        this.result = this.tagList.filter((item) => {
          let idx = ids.findIndex(id => item.Id == id)
          return idx >= 0
        })

        this.defaultResult = JSON.parse(JSON.stringify(this.result))
      }
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
      if (this.result.length === this.maxCount) {
        this.$tips.error(`最多选择${this.maxCount}个！`)
      }
    },
    submit() {
      publishTagServices.setTags({
        currTags: this.result,
        currTagNames: this.result.map(t => t.Name)
      })
      this.goBack()
    },
    handleBack() {
      if (this.defaultResult) {
        this.result = this.defaultResult
      }
      this.goBack()
    },
    plusBtn() {
      let currIdx = this.tagList.findIndex(t => t.Name === this.insetTagVal)
      if (!this.insetTagVal) {
        return this.$tips.error('请输入标签')
      } 
      if (currIdx >= 0) {
        return this.$tips.error('请勿输入同样的标签')
      } 
      let reqMsg = {Name: this.insetTagVal, UserId: this.UserId}
      this.$api(Cms.InsertTag,reqMsg)
        .then(() => {
          this.tagList.push(reqMsg)
          if (this.maxCount > this.result.length) {
            this.result.push(reqMsg)
            
          }
          this.insetTagVal = ''
        })
    }
  }
}
</script>

<style scoped lang="scss">
.choose-tags--page {
  .add-box {
    padding: 20px 12px;
  }
  .border-input .plus {
    padding-top: 3px;
  }
}
</style>
